import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import { useNewsletterForm, useNewsletter } from './hooks'
import NewsletterAlert from './NewsletterAlert'
import NewsletterIcon from './NewsletterIcon'
import NewsletterForm from './NewsletterForm'
import EmailAlert from '../../../static/assets/emailAlert.svg'

function Newsletter() {
  const [hasAlert, setHasAlert] = useState(false)
  const { 
    api,
    name,
    profile,
    otherProfile,
    email,
    setEmail,
    setProfile,
    onChangeEmail,
    onChangeName,
    onChangeProfile,
    onChangeOtherProfile,
    isInvalidEmail
  } = useNewsletter()
  const {
    onSubmit,
    isLoading,
    isSubmitted,
    setIsSubmitted,
    isSuccessfullyRegistered,
    hasEmailRegistered,
    hasServerError,
  } = useNewsletterForm(api, email, name, profile, otherProfile, setEmail, setProfile)
  const { t } = useTranslation()

  useEffect(() => setHasAlert(isSuccessfullyRegistered || hasEmailRegistered || hasServerError), [
    isSuccessfullyRegistered,
    hasEmailRegistered,
    hasServerError,
  ])

  return (
    <section className={styles.newsletter}>
      <NewsletterIcon isSuccessfully={hasEmailRegistered || isSuccessfullyRegistered} isError={hasServerError} />

      <div className={styles.newsletterContent}>
        <span className={styles.newsletterTitle}>{t('newsletter.title')}</span>
        <p className={styles.newsletterDescription}>{t('newsletter.description')}</p>

        {!hasAlert && (
          <NewsletterForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            isSubmitted={isSubmitted}
            onChangeEmail={onChangeEmail}
            onChangeName={onChangeName}
            onChangeProfile={onChangeProfile}
            onChangeOtherProfile={onChangeOtherProfile}
            profile={profile}
            isInvalidEmail={isInvalidEmail}
          />
        )}

        <NewsletterAlert
          setIsSubmitted={setIsSubmitted}
          isSuccessfullyRegistered={isSuccessfullyRegistered}
          hasEmailRegistered={hasEmailRegistered}
          hasServerError={hasServerError}
        />
      </div>
      <EmailAlert />
    </section>
  )
}

export default Newsletter
